export const checkboxSchema = require('./checkbox.json');
export const clinicalFigureSchema = require('./clinicalfigure.json');
export const commentSchema = require('./comment.json');
export const minMaxSchema = require('./minmax.json');
export const radioSchema = require('./radio.json');
export const radioTableSchema = require('./radiotable.json');
export const scoreSchema = require('./score.json');
export const timePickerSchema = require('./time.json');
